import { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Mail, ArrowLeft, CheckCircle } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { setError("Introduce tu email"); return; }
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch {
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-sm rounded-sm border-slate-200" data-testid="forgot-password-card">
        <CardHeader className="text-center pb-3">
          <CardTitle className="text-lg font-bold uppercase tracking-wider text-slate-900">Recuperar Contrasena</CardTitle>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="text-center space-y-4 py-4" data-testid="forgot-success">
              <CheckCircle className="w-12 h-12 text-green-500 mx-auto" />
              <p className="text-sm text-slate-600">
                Si el correo existe en el sistema, recibiras instrucciones para restablecer tu contrasena.
              </p>
              <Link to="/login">
                <Button variant="outline" className="rounded-sm text-xs uppercase mt-2" data-testid="back-to-login-btn">
                  <ArrowLeft className="w-3 h-3 mr-1" /> Volver al login
                </Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <p className="text-xs text-slate-500">Introduce tu email y te enviaremos instrucciones para restablecer tu contrasena.</p>
              <div className="space-y-1">
                <Label className="text-xs uppercase tracking-wider font-semibold text-slate-600">Email</Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-2.5 w-4 h-4 text-slate-400" />
                  <Input type="email" value={email} onChange={e => setEmail(e.target.value)}
                    placeholder="tu@email.com" className="pl-9 rounded-sm h-9 border-slate-200" data-testid="forgot-email-input" />
                </div>
              </div>
              {error && <p className="text-xs text-red-500">{error}</p>}
              <Button type="submit" disabled={loading}
                className="w-full bg-slate-900 hover:bg-slate-800 rounded-sm text-xs uppercase font-semibold h-9" data-testid="forgot-submit-btn">
                {loading ? "Enviando..." : "Enviar instrucciones"}
              </Button>
              <Link to="/login" className="block text-center">
                <span className="text-xs text-slate-500 hover:text-slate-700 underline">Volver al login</span>
              </Link>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
